import { render, staticRenderFns } from "./ElementIcon.vue?vue&type=template&id=eb8dc262&"
import script from "./ElementIcon.vue?vue&type=script&lang=ts&"
export * from "./ElementIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports